import React from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'
export const DeleteRepairInventoryItem = ({
  repairInventoryItem,
  onDelete,
  onError,
     text="Delete"
}) => {
  const dispatch = useDispatch()
  let OnDeleteConfirm = function () {
      text==="Delete"? new rest.RepairInventoryService(repairInventoryItem.url)
      .makeDeleteRequest()
      .then((response) => {
        onDelete(repairInventoryItem)
        dispatch(showSuccessToast('Success', 'Repair Inventory Items deleted.'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      }):
          new rest.RepairInventoryService(repairInventoryItem.url)
      .cancel()
      .then((response) => {
        onDelete(repairInventoryItem)
        dispatch(showSuccessToast('Success', 'Repair Inventory Items deleted.'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={OnDeleteConfirm}
      body={`Are you sure you want to mark this Repair Inventory  item ${text}?`}
        confirmText={`Confirm ${text} Repair Inventory  Item`}
        confirmBSStyle="danger"
        title={`${text} Repair Inventory  Item`}
      >
        <ReactBootstrap.Dropdown.Item variant="dark" eventKey="1">
          {text==="Delete"?components.ICONS.DELETE: components.ICONS.RETURN} {text}
        </ReactBootstrap.Dropdown.Item>
      </components.Confirm>
    </>
  )
}
